module.exports = __webpack_public_path__ + "img/train7.7c342dab.gif";